import { createContext, useContext } from 'react'
import type { IObjectFormController } from './IObjectFormController'

export const ObjectFormContext = createContext<IObjectFormController | null>(null)

export function useObjectFormContext(): IObjectFormController {
  const ctx = useContext(ObjectFormContext)
  if (!ctx) throw new Error('useObjectFormContext must be used within ObjectFormContext.Provider')
  return ctx
}
